import { useState } from "react";
import { teamHighlights } from "@/mocks/games";

export default function TeamHighlights() {
  const [active, setActive] = useState(0);
  const team = teamHighlights[active];

  return (
    <section id="teams" className="bg-[#0a0a0a] py-24 px-4 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-4">
          <div>
            <span className="text-[#e8c34a] text-xs uppercase tracking-[0.3em] font-semibold block mb-3">
              Top Contenders
            </span>
            <h2 className="text-white font-black text-4xl md:text-6xl uppercase leading-none">
              Team
              <br />
              Highlights
            </h2>
          </div>
          <p className="text-white/50 text-sm max-w-sm leading-relaxed">
            The world&apos;s best squads are ready to battle for football immortality. Explore the teams that will define 2026.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8">
          {/* Team selector */}
          <div className="flex flex-row lg:flex-col gap-3 overflow-x-auto lg:overflow-visible pb-2 lg:pb-0 flex-shrink-0">
            {teamHighlights.map((t, i) => (
              <button
                key={t.id}
                onClick={() => setActive(i)}
                className={`flex items-center gap-3 px-4 py-3 rounded-xl border transition-all cursor-pointer whitespace-nowrap min-w-max lg:min-w-0 ${
                  active === i
                    ? "bg-[#e8c34a] border-[#e8c34a] text-black"
                    : "bg-white/5 border-white/10 text-white/70 hover:bg-white/10 hover:border-white/20"
                }`}
              >
                <span className="text-2xl">{t.flag}</span>
                <span className="font-bold text-sm uppercase tracking-wider">{t.country}</span>
                <span className={`text-xs font-medium ml-auto pl-4 ${active === i ? "text-black/60" : "text-white/30"}`}>
                  #{t.ranking}
                </span>
              </button>
            ))}
          </div>

          {/* Main card */}
          <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="relative rounded-2xl overflow-hidden" style={{ minHeight: "420px" }}>
              <img
                src={team.image}
                alt={`${team.country} team`}
                className="w-full h-full object-cover object-top absolute inset-0"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 p-6">
                <span className="text-5xl mb-2 block">{team.flag}</span>
                <h3 className="text-white font-black text-3xl uppercase">{team.country}</h3>
                <p className="text-white/60 text-sm mt-1">FIFA Ranking #{team.ranking}</p>
              </div>
            </div>

            <div className="flex flex-col gap-4">
              {/* Stats card */}
              <div className="bg-white/5 border border-white/10 rounded-2xl p-6">
                <h4 className="text-[#e8c34a] text-xs uppercase tracking-[0.3em] font-semibold mb-4">
                  Squad Overview
                </h4>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p className="text-white font-black text-4xl">{team.wins}</p>
                    <p className="text-white/50 text-xs uppercase tracking-wider mt-1">Qual. Wins</p>
                  </div>
                  <div>
                    <p className="text-white font-black text-4xl">#{team.ranking}</p>
                    <p className="text-white/50 text-xs uppercase tracking-wider mt-1">World Rank</p>
                  </div>
                </div>
              </div>

              {/* Key players */}
              <div className="bg-white/5 border border-white/10 rounded-2xl p-6 flex-1">
                <h4 className="text-[#e8c34a] text-xs uppercase tracking-[0.3em] font-semibold mb-4">
                  Key Players to Watch
                </h4>
                <div className="flex flex-col gap-3">
                  {team.players.map((player, i) => (
                    <div
                      key={player}
                      className="flex items-center gap-3 bg-white/5 rounded-lg px-4 py-3"
                    >
                      <span className="w-6 h-6 flex items-center justify-center rounded-full bg-[#e8c34a]/20 text-[#e8c34a] text-xs font-bold">
                        {i + 1}
                      </span>
                      <span className="text-white font-semibold text-sm">{player}</span>
                      <span className="ml-auto text-white/30 text-xs">⭐ Star</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Watch button */}
              <div className="flex items-center justify-center gap-2 bg-white/5 border border-white/10 text-white/40 px-6 py-4 rounded-xl uppercase tracking-wider text-sm whitespace-nowrap cursor-default select-none">
                <i className="ri-play-circle-line text-base"></i>
                Highlights Coming Soon
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
